module.exports = __webpack_public_path__ + "img/new-treatment-modal-desktop-ru.428d3a25.jpg";